import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as homestayActions from './../../../../../actions/homestayAction';
import * as locationActions from './../../../../../actions/locationAction';
import {uploadAction} from './../../../../../actions/uploadAction';
import {getListProvinces} from './../../../../../actions/generalAction';
import * as amenityActions from './../../../../../actions/amenityAction';
import HomestayDetail from './HomestayDetail';

const mapStateToProps = state => {
    return {
        homestayState: state.homestayReducer,
        uploadState: state.uploadReducer,
        generalState: state.generalReducer,
        locationState: state.locationReducer,
        amenityState: state.amenityReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListAmenities: () => dispatch(amenityActions.getListAmenity()),
        getHomestayDetail: (id) => dispatch(homestayActions.getHomestayDetail(id)),
        setHomestayDetail: (homestay) => dispatch(homestayActions.setHomestayDetail(homestay)),
        updateHomestayDetail: (homestay) => dispatch(homestayActions.updateHomestayDetail(homestay)),
        createHomestayDetail: (homestay) => dispatch(homestayActions.createHomestayDetail(homestay)),
        getListLocations: (filters) => dispatch(locationActions.getListLocations(filters)),
        onUploadFile: (filters) => dispatch(uploadAction(filters)),
        getProvinces: () => dispatch(getListProvinces()),
        createHomestayTranslate: (homestay, language) => dispatch(homestayActions.createHomestayTranslate(homestay, language)),
        updateHomestayTranslate: (homestay, language) => dispatch(homestayActions.updateHomestayTranslate(homestay, language)),
        deleteHomestayTranslate: (homestay, refreshParams) => dispatch(homestayActions.deleteHomestayTranslate(homestay, refreshParams)),
        getTagGroupDetailSku: (id) => dispatch(homestayActions.getTagGroupDetailSku(id)),
        setTagGroupDetailSku: (data) => dispatch(homestayActions.setTagGroupDetailSku(data)),
        updateTagGroupDetailSkuActive: (tagsGroup, id) => dispatch(homestayActions.updateTagGroupDetailSkuActive(tagsGroup, id)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(HomestayDetail));
